// eslint-disable-next-line import/no-extraneous-dependencies
import { TypeOptions, toast } from 'react-toastify';

export const typeOptions: { [key: string]: TypeOptions } = {
  info: 'info',
  success: 'success',
  warning: 'warning',
  error: 'error',
  default: 'default',
};

export const Toast = (message: string, type: TypeOptions) => {
  toast(message, {
    type,
    position: toast.POSITION.BOTTOM_CENTER,
    theme: 'light',
    autoClose: 1500,
    hideProgressBar: false,
    closeButton: false,
  });
};
